function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
  fill: "#F4C14D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.7788 158.91C46.9743 161.442 48.0008 163.487 49.8584 165.045C51.7648 166.554 54.2823 167.309 57.4109 167.309C60.0017 167.309 62.1036 166.773 63.7168 165.702C65.3788 164.582 66.2098 163.049 66.2098 161.101C66.2098 159.738 65.7455 158.667 64.8167 157.888C63.9368 157.06 62.6658 156.427 61.0038 155.989C59.3906 155.502 56.8731 154.918 53.4513 154.236C50.0784 153.603 47.2431 152.8 44.9456 151.826C42.6481 150.803 40.7661 149.318 39.2996 147.371C37.882 145.375 37.1732 142.745 37.1732 139.483C37.1732 136.513 37.9798 133.86 39.5929 131.522C41.2549 129.185 43.528 127.36 46.4121 126.045C49.3451 124.682 52.6447 124 56.311 124C60.075 124 63.4479 124.706 66.4298 126.118C69.4606 127.481 71.8314 129.38 73.5423 131.815C75.3021 134.249 76.2065 137 76.2553 140.067H65.4766C65.2322 137.876 64.3034 136.124 62.6902 134.809C61.0771 133.446 58.9507 132.764 56.311 132.764C53.8668 132.764 51.9115 133.275 50.445 134.298C48.9785 135.32 48.2453 136.781 48.2453 138.68C48.2453 140.043 48.6852 141.114 49.5651 141.893C50.445 142.624 51.6915 143.232 53.3047 143.719C54.9178 144.157 57.4109 144.693 60.7838 145.326C64.2056 145.959 67.0897 146.762 69.4361 147.736C71.7825 148.661 73.6645 150.097 75.0821 152.045C76.5486 153.944 77.2819 156.5 77.2819 159.713C77.2819 162.83 76.4264 165.629 74.7155 168.112C73.0046 170.547 70.6093 172.47 67.5297 173.882C64.4989 175.294 61.0771 176 57.2642 176C53.158 176 49.4918 175.27 46.2655 173.809C43.0881 172.3 40.595 170.23 38.7863 167.601C36.9777 164.972 36.0489 162.026 36 158.764L46.7788 158.91Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M83.8811 124.438H94.8799V175.562H83.8811V124.438Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M103.573 175.562L103.573 124.438H114.572L114.572 166.14L134.956 166.14V175.562L103.573 175.562Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M127.673 124.438H139.331L151.65 162.27L164.262 124.438H175.627L158.249 175.562H145.124L127.673 124.438Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M180.048 124.438H214.511V133.86H191.047V145.326H210.112V154.309H191.047V166.14H215.318V175.562H180.048V124.438Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M242.836 124.438C246.551 124.438 249.826 125.144 252.661 126.556C255.545 127.919 257.77 129.891 259.334 132.472C260.898 135.052 261.68 138.047 261.68 141.455C261.68 144.717 260.898 147.614 259.334 150.146C257.77 152.629 255.619 154.528 252.881 155.843L263 175.562H250.828L242.249 158.399H232.937V175.562L221.938 175.562V124.438H242.836ZM232.937 149.27L241.956 149.27C244.547 149.27 246.6 148.564 248.115 147.152C249.679 145.74 250.461 143.841 250.461 141.455C250.461 139.021 249.679 137.097 248.115 135.685C246.6 134.273 244.547 133.567 241.956 133.567H232.937V149.27Z",
  fill: "white"
});

var SvgSilver = function SvgSilver(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSilver, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SILVER.8a021b72.svg";
export { ForwardRef as ReactComponent };